import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from 'tss-react/mui';
import { getConf } from '@jbrowse/core/configuration';
import { ResizeHandle } from '@jbrowse/core/ui';
var useStyles = makeStyles()(function () {
  return {
    resizeHandle: {
      height: 2,
      position: 'absolute',
      zIndex: 2
    }
  };
});
function AlignmentsDisplay(_ref) {
  var model = _ref.model;
  var PileupDisplay = model.PileupDisplay,
    SNPCoverageDisplay = model.SNPCoverageDisplay;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var top = SNPCoverageDisplay.height;
  return React.createElement("div", {
    "data-testid": "display-".concat(getConf(model, 'displayId')),
    style: {
      position: 'relative'
    }
  }, React.createElement("div", {
    "data-testid": "Blockset-snpcoverage"
  }, React.createElement(SNPCoverageDisplay.RenderingComponent, {
    model: SNPCoverageDisplay
  })), React.createElement(ResizeHandle, {
    onDrag: function onDrag(delta) {
      SNPCoverageDisplay.setHeight(SNPCoverageDisplay.height + delta);
      return delta;
    },
    className: classes.resizeHandle,
    style: {
      top: top
    }
  }), React.createElement("div", {
    "data-testid": "Blockset-pileup",
    style: {
      position: 'absolute',
      top: top
    }
  }, React.createElement(PileupDisplay.RenderingComponent, {
    model: PileupDisplay
  })));
}
export default observer(AlignmentsDisplay);